import { api } from "@/services";
import { useEffect, useState } from "react";
import { useIsomorphicLayoutEffect } from "@/hooks/Custom";
import { ClientObject } from "@/types/Shared";

const useAsynClientById = async (clientId: string) => {
  let Response: ClientObject = null;
  let CError: string = null;

  const Controller = new AbortController();

  const MakeRequest = async () => {
    try {
      const resp = await api.get(`/Client/GetClienteById?id=${clientId}`, {
        signal: Controller.signal
      });
      if (resp.status === 200) {
        Response = resp.data;
      } else {
        CError = "Não fo encontrado";
      }
    } catch (error) {
      CError = error.message;
    }
  };

  await MakeRequest();

  Controller.abort();

  return [Response, CError];
};

export { useAsynClientById };
